import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { modalActions, inputTilesActions } from '../../redux/root-action';
import { scroller } from 'react-scroll';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { isMobileApp, getDomain } from '../../utils/api';
import { modals } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledHeaderText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey800};
  padding-top: 16px;
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey900};
  margin: 16px 0px 56px 0px;
`;

const StyledUl = styled.ul`
  list-style: disc;
  padding-left: 32px;
`;

class InformationAndAssumptions extends Component<any, any> {
  handleLearnMoreClick = () => {
    const { hideModal, showModal } = this.props;
    const element = document.getElementById('rix-assumptions-text-open');
    if (isMobileApp()) {
      showModal(modals.RIX_ASSUMPTIONS);
    } else {
      window.location.href = getDomain() + '/workplace/en/participant/home/methodology-and-assumptions.html';
    }
  };

  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Information and Assumptions'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            <StyledHeaderText>How are my retirement income estimates and projections calculated?</StyledHeaderText>
            Unless you&#39;ve entered a Retirement Income Goal, we estimate the percentage of your current salary
            required to maintain your lifestyle in retirement, which could last 30 years or more. This amount is based
            on your spending needs. Higher withdrawal amounts may be necessary due to withholding requirements or the
            need to pay taxes. To calculate your income goal (shown in today’s dollars), we subtract certain estimated
            taxes (state, federal and employment taxes) and any regular contributions made to your account(s) from your
            projected salary at retirement. Then we estimate how long your savings will last if you live off your
            Retirement Income Goal.
            <br />
            <br />
            If you select the ‘Make My Savings Last’ chart view, we estimate how much income you’ll have if you want
            your savings to last through retirement. If you add spouse information, we will include it in our
            calculations, and the resulting estimates and projections. These estimates can help you assess your needs
            based on your goals and the timing of your retirement. Note that all estimated income is shown in today’s
            dollars and projected balances are shown in future dollars, unless otherwise indicated.
            <StyledHeaderText>How can I improve my outlook?</StyledHeaderText>
            Many factors can impact your retirement outlook. Here are a few ways to improve it.
            <StyledUl>
              <li>
                In your working years, we believe you should start saving as much as you can as early as you can so your
                money has time to grow.
              </li>
              <li>If you can’t save enough at first, you can reach your savings goals one increase at a time.</li>
              <li>
                Later in life,you might consider delaying retirement to make the most of your savings and/or waiting to
                claim Social Security until you are able to maximize your benefit.
              </li>
              <li>You can also consider adjusting your lifestyle in retirement.</li>
            </StyledUl>
            You can see the impact of adjusting these and other factors in the Retirement Income Planner.
            <StyledHeaderText>Assumptions</StyledHeaderText>
            To generate your retirement income estimates and assess the impact of adjustments to your savings rate, time
            horizon, market fluctuations and other factors, we run your salary, retirement age and account information
            through 500 market scenarios. Our monthly and annual retirement income estimates show spendable, after-tax
            amounts that succeed in at least 80% of these market simulations. (i.e. leave at least $0.01 in the plan at
            the end of retirement). 
            <Link
              linkLabel="Learn more about our methodology and assumptions used to calculate your retirement projections and estimates."
              customStyles={'font-family: Nimbus Sans Bold; display: inline'}
              onClick={this.handleLearnMoreClick}
              underline={true}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleLearnMoreClick)}
            />
          </StyledText>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Learn More"
          hideCancel={true}
          buttonType="textButton"
          handleCTAClick={this.handleLearnMoreClick}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
  showInputTilePopover: inputTilesActions.showInputTilePopover,
})(InformationAndAssumptions);
